'use client';

import { useEffect } from 'react';

import { YM_COUNTER_ID } from '@/shared/const/ym';
import { useSession } from '@/shared/hooks/use-session';
import { getLocalStorageCart } from '@/entities/cart/utils';
import { getLocalStorageFavorites } from '@/entities/favorite/utils';
import {
  useAddManyMasterclassesToCartMutation,
} from '@/entities/cart/query';
import {
  useAddManyMasterclassesToFavoritesMutation,
} from '@/entities/favorite/query';

export function YMetrikaProvider({ children }: { children: React.ReactNode }) {
  const { user: currentUser } = useSession();

  useEffect(() => {
    // @ts-ignore
    if (currentUser && window.ym) {
      // @ts-ignore
      window.ym(YM_COUNTER_ID, 'userParams', {
        UserID: currentUser.strapiUserId,
        username: currentUser.name,
        email: currentUser.email,
      });
      // @ts-ignore
      window.ym(YM_COUNTER_ID, 'params', {
        email: currentUser.email,
      });
    }
  }, [currentUser]);
  const { mutateAsync: addManyMasterclassesToCart } =
    useAddManyMasterclassesToCartMutation();
  const { mutateAsync: addManyMasterclassesToFavorites } =
    useAddManyMasterclassesToFavoritesMutation();

  useEffect(() => {
    if (!currentUser?.strapiUserId) {
      return;
    }
    const joinCart = async () => {
      const localStorageCart = getLocalStorageCart();
      if (localStorageCart?.length > 0) {
        await addManyMasterclassesToCart(localStorageCart);
      }
    };
    const joinFavorites = async () => {
      const localStorageFavorites = getLocalStorageFavorites();
      if (localStorageFavorites?.length > 0) {
        await addManyMasterclassesToFavorites(localStorageFavorites);
      }
    };
    joinCart();
    joinFavorites();
  }, [
    addManyMasterclassesToCart,
    addManyMasterclassesToFavorites,
    currentUser?.strapiUserId,
  ]);
  return <>{children}</>;
}
